module.exports = __webpack_public_path__ + "img/remitpro.c143f98d.png";